// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7b09d449","186":"cec79b63","272":"4531d37d","372":"63334f79","738":"39adbd6d","841":"adf3b06f","851":"2e2ff5cf","856":"048ed4bc"}[chunkId] + ".chunk.js";
};